// extracted by mini-css-extract-plugin
module.exports =  {"avatar":"_0bc5e8de02--avatar--ceW9Q","clickable":"_0bc5e8de02--clickable--jjxbB","company":"_0bc5e8de02--company--MXKHY"};